/* index.tsx generated by @compiled/babel-plugin v2.0.0 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDS5Zs%7Bborder-radius%3Avar(--ds-radius-full%2C9999px)%7D");
import { useEffect, useState, type ReactNode } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import ImageLoader from 'react-render-image';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { LoadingSkeleton } from '../loading-skeleton';
import { type ImageIconProps } from './types';
const styles = {
  roundImg: "_0bjKvDS5Zs"
};
const messages = defineMessages({
  imageAltText: {
    id: 'smart-link.image-icon.altText',
    defaultMessage: 'Link Icon',
    description: 'Alternative text for the link icon image displayed on a flexible smart link card, used by screen readers and when the image cannot be rendered.'
  }
});
const ImageIcon = ({
  label,
  defaultIcon,
  testId,
  url,
  width,
  height,
  appearance = 'square',
  onError,
  onLoad,
  hideLoadingSkeleton = false
}: ImageIconProps): string | number | boolean | Iterable<ReactNode> | JSX.Element | null | undefined => {
  const [hasImageErrored, setHasImageErrored] = useState(false);
  const {
    formatMessage
  } = useIntl();

  // If url changes, reset state
  useEffect(() => {
    setHasImageErrored(false);
  }, [url]);
  if (hasImageErrored) {
    return defaultIcon;
  }
  if (hideLoadingSkeleton) {
    return <img src={url} data-testid={`${testId}-image`} alt={fg('platform_navx_smart_link_icon_label_a11y') ? label?.trim() ?? '' : ''} style={{
      width,
      height
    }} onError={() => setHasImageErrored(true)} className={ax([appearance === 'round' && styles.roundImg])} />;
  } else {
    return <ImageLoader src={url} loading={<LoadingSkeleton testId={`${testId}-loading`} width={width} height={height} />} loaded={<img src={url} data-testid={`${testId}-image`} alt={fg('platform_navx_smart_link_icon_label_a11y') ? label?.trim() ?? '' : formatMessage(messages.imageAltText)} style={{
      width,
      height
    }} className={ax([appearance === 'round' && styles.roundImg])} />} errored={defaultIcon} onError={onError} onLoad={onLoad} />;
  }
};
export default ImageIcon;